module.exports = __webpack_public_path__ + "441b4fdbc6ba7c9c23057a82c2fec922.svg";